import { WidgetHeader } from 'legacy/lut/components/widgets/public/partner360/widgetHeader/WidgetHeader'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import styles from './ErrorLoadingDataDialogContent.module.scss'

interface IProps {
  onConfirm: () => void
}

export const ErrorLoadingDataDialogContent = ({ onConfirm }: IProps) => {
  return (
    <div className={styles.root}>
      <WidgetHeader>jbp-planning-error-loading-data-title</WidgetHeader>
      <div className={styles.message}>
        <Translation text="jbp-planning-error-loading-data" />
      </div>
      <div className={styles.buttonContainer}>
        <Button className={styles.btns__btn} onClick={onConfirm}>
          <Translation text="jbp-planning-error-loading-data-confirm" />
        </Button>
      </div>
    </div>
  )
}
